import React, {useEffect, useState} from 'react'
import axios from 'axios'
import {
	Link
} from 'react-router-dom';
import Loader from '../../components/Loader';
import axiosInstance from '../../utils/api';

type Props = {}
interface CustomerInterface {
    customerid: string;
    location?: string;
    name?: string;
    platform_fees? :string|null
}

const CustomerList = (props: Props) => {
    const title = "Customer"
    const [loading, setLoading] = useState(false)
    const [customers, setCustomers] = useState<Array<CustomerInterface>>([])

    useEffect(() => {
        getDateList()
    }, [])

    function getDateList() {
        setLoading(true)
        axiosInstance.get("https://api.cl-ds.com/internal/operations/v1/customer").then(res=>{
            setLoading(false)
            console.log(res.data)
            setCustomers(res.data)
        }).catch(err=>{
            setLoading(false)
            console.log(123, err)
        })
    }

    function handleDelete(id:string) {
        if (!window.confirm("Are you sure you want to delete record?")) return
        
        setLoading(true)
        axiosInstance.delete(`https://api.cl-ds.com/internal/operations/v1/customer/${id}/`).then(res=>{
            setLoading(false)
            console.log(11, res)
            alert(res.data.message)
            getDateList()
        }).catch(err=>{
            setLoading(false)
            console.log(123, err)
        })
    }

    const [equipmentModalStatus, setEquipmentModalStatus] = useState(false)
    const [equipmentList, setEquipmentList] = useState([])

    function showEquipment(customerId:string) {
        setEquipmentModalStatus(true)
        setLoading(true)

        axiosInstance.get("https://api.cl-ds.com/internal/operations/v1.0/list/equipment/"+customerId).then(res=>{
            setLoading(false)
            setEquipmentList(res.data)
        }).catch(err=>{
            setLoading(false)
            console.log(123, err)
        })
    }
    

    return (
        <>
            <div className="col-12">
            {loading && ( <Loader/> )}

                <div className="card">
                    <div className="card-body">
                        <div className="row px-2" style={{display:"grid", gridTemplateColumns:"1fr 1fr"}}>
                            <h5 className="card-title">{title} List</h5>
                            <div style={{display:"flex", justifyContent:"end", alignSelf:"center"}}>
                                
                                <Link to="/customer/add" >
                                    <button type="button" className="btn btn-outline-info">Create</button>
                                </Link>
                            </div>

                        </div>


                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col">Location</th>
                                    <th scope="col">Customer ID</th>
                                    <th scope="col">Platform Fees</th>
                                    <th scope="col">List of Equipment</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {customers.map( (customer, index) => {

                                    return (
                                        <tr key={index}>
                                            <th scope="row">{customer.name}</th>
                                            <td>{customer.location}</td>
                                            <td>{customer.customerid}</td>
                                            <td>{customer.platform_fees}</td>
                                            <td>
                                                <button type="button" className="btn btn-outline-info" onClick={()=>{
                                                    showEquipment(customer.customerid)
                                                }}>Show</button>
                                            </td>
                                            <td>
                                                <Link to={`/customer/edit/${customer.customerid}`} >
                                                    <button type="button" className="btn btn-outline-info"><i className="bi bi-pencil"></i></button>
                                                </Link>
                                                <button type="button" className="btn btn-outline-danger mx-1" onClick={()=>{handleDelete(customer.customerid.toString())}}><i className="bi bi-trash"></i></button>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    

                    </div>
                </div>

            </div>

            <div className="modal fade show" style={equipmentModalStatus ? {display:'block'} : {display: 'none'}}>
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLongTitle">{"Equipment List"}</h5>
                    </div>
                    <div className="modal-body">
                        <div className="table-responsive">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">Product</th>
                                        <th scope="col">Serial</th>
                                        <th scope="col">Condition</th>
                                        <th scope="col">Date of Installation</th>
                                        <th scope="col">Simcard</th>
                                        <th scope="col">List of Sensor</th>
                                        <th scope="col">Pump A</th>
                                        <th scope="col">Pump B</th>
                                        <th scope="col">Pump C</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {equipmentList.map( (equipment:any, index) => {
                                        return (
                                            <tr key={index}>
                                                <th scope="row">{equipment.product}</th>
                                                <td>{equipment.serial}</td>
                                                <td>{equipment.condition}</td>
                                                <td>{equipment.date_installation}</td>
                                                <td>{equipment.simcard}</td>
                                                <td>{(equipment.sensor && equipment.sensor.length > 0) ? (
                                                    <>
                                                    {equipment.sensor.map((eq:any) => {
                                                        return (<>&#x2022;{eq.serial}<br/></>)
                                                    })}
                                                    </>
                                                ) : (<td></td>)}
                                                </td>
                                                <td>{equipment.pumpa}</td>
                                                <td>{equipment.pumpb}</td>
                                                <td>{equipment.pumpc}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={()=>{
                            setEquipmentModalStatus(false)
                            setEquipmentList([])
                        }}>Close</button>
                    </div>
                    </div>
                </div>
            </div>
            </>

    )
}

export default CustomerList